export enum LanguageShortName {
  ENGLISH = 'en',
  FRENCH = 'fr',
  SINHALA = 'sin',
}

export enum LanguageFullName {
  ENGLISH = 'English',
  FRENCH = 'Français',
  SINHALA = 'සිංහල',
}
